import React  from "react";
import { Flex, Box,GridItem} from '@chakra-ui/react';
import {useState,useEffect} from "react"
import {useSelector,useDispatch} from "react-redux";
import { getData } from "../../Redux/app/action";
import {Link} from "react-router-dom"
import {
    ChevronLeftIcon,
    ChevronRightIcon,
  } from '@chakra-ui/icons';

import ImgCard  from "../ImgCard";
export const MyCarousel=()=>{
    const cards = useSelector((state)=>state.appReducer.cards);
    const dispatch=useDispatch();
    const [stop, setStop] = useState(3);
    const [start, setStart] = useState(1);

    useEffect(() => {
        dispatch(getData());
    }, [cards.length]);
    // console.log(cards,"start")
    const [data, setData] = useState(cards);

useEffect(() => {
    if (data.length === 0) {
        setData(cards);
    }
}, [cards, data.length]);
    
    // console.log(data);
    const handlePrev = () => {
        let d = [...data];
        let x = d.pop();
        d.unshift(x);
        setData(d);
        { stop <= 3 ? setStop(3) : setStop(prev => prev - 1) };
        {start<=0?setStart(0):setStart(prev=>prev-1)}
    }
    const handleNext = () => {

        let d = [...data];
        let x = d.shift();
        d.push(x);
        setData(d);
        setStop(prev => prev + 1);
        setStart(prev => prev + 1);
    }
    // console.log(cards[0])
    return (
    <Flex marginBottom={'2%'} justify='center' width='95%'align='center' height='530px' marginTop={'-2%'}>
           <Box onClick={handlePrev} ><ChevronLeftIcon w='12' h='12' color='#01BFBD'
/></Box>
            <Flex w="80%" justify='center' >
                {data ?.filter((item)=>item.id<=stop&&item.id>=start).map((item) => (
                    <GridItem key={item.id}>
                        <Link to={`/fundraiserDetails/${item.id}`}>
                        <ImgCard 
  raised={item.raised}
  total={item.total}
  quote={item.quote}
  beneficiary={item.beneficiary}
  beneficiaryLogo={item.beneficiaryLogo}
  days={item.days}
  supporters={item.supporters}
  banner={item.banner}
/>
</Link>
                    </GridItem>
                ))}
           </Flex>
           <Box onClick={handleNext}><ChevronRightIcon w='12' h='12' color='#01BFBD'/>
</Box>
    </Flex>
    )
}